import { createContext, type ReactNode, useContext } from "react";

import classes from "./ShaftSummaryStepFrame.module.less";
import EditButton from "~/Configurators/common/components/ConfigurationSummaryComponent/EditButton/EditButton";

interface Props {
  stepNumber: number;
  name: ReactNode;
  children?: ReactNode;
  showEdit?: boolean;
}

export const ShaftSummaryStepFrame = ({ stepNumber, name, children, showEdit = true }: Props) => {
  const onStepChange = useContext(OnStepChangeContext);
  return (
    <div className={classes.root}>
      <p className={classes.title}>
        <span className={"f-pre"}>{stepNumber}. </span>
        <span>{name}</span>
      </p>
      {children && <div>{children}</div>}
      {showEdit && <EditButton className={""} index={stepNumber - 1} onStepChange={onStepChange} />}
    </div>
  );
};

type Fn = () => void;
const OnStepChangeContext = createContext<Fn | undefined>(undefined);
export const OnStepChangeContextProvider = OnStepChangeContext.Provider;
